import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { recruitmentApi } from '../axios';

export const useJobs = (params) => useQuery({
  queryKey: ['recruitment', 'jobs', params],
  queryFn: () => recruitmentApi.get('/v1/recruitment/jobs', { params }).then(r => r.data),
  staleTime: 30000,
});

export const useJob = (jobId) => useQuery({
  queryKey: ['recruitment', 'jobs', jobId],
  queryFn: () => recruitmentApi.get(`/v1/recruitment/jobs/${jobId}`).then(r => r.data),
  enabled: !!jobId,
  staleTime: 30000,
});

export const useJobCandidates = (jobId) => useQuery({
  queryKey: ['recruitment', 'jobs', jobId, 'candidates'],
  queryFn: () => recruitmentApi.get(`/v1/recruitment/jobs/${jobId}/candidates`).then(r => r.data),
  enabled: !!jobId,
  staleTime: 30000,
});

export const useCreateJob = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) => recruitmentApi.post('/v1/recruitment/jobs', payload).then(r => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['recruitment', 'jobs'] }),
  });
};

export const useAddCandidate = (jobId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) => recruitmentApi.post(`/v1/recruitment/jobs/${jobId}/candidates`, payload).then(r => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['recruitment', 'jobs', jobId, 'candidates'] }),
  });
};

export const useMoveCandidate = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, stage }) => recruitmentApi.patch(`/v1/recruitment/candidates/${id}/stage`, { stage }).then(r => r.data),
    onSuccess: (_, { jobId }) => qc.invalidateQueries({ queryKey: ['recruitment', 'jobs', jobId, 'candidates'] }),
  });
};

export const useCloseJob = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => recruitmentApi.patch(`/v1/recruitment/jobs/${id}/close`).then(r => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['recruitment', 'jobs'] }),
  });
};
